var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * Service to search for a consumer by phone or name
 *
 * @class ConsumerInfoWS
 */
function ConsumerInfoWS() {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.consumerName = null;
  self.lastSeen = ko.observable(null);
  self.notes = ko.observable();
  self.name = 'ConsumerInfoWS';
  self.method('POST');


	/**
	 * Abstract override method
	 *
	 * @method doRequest
	 * @param {Function} callbackFn the fn to invoke on successful request
   * @param {number} locationId the ID of Location where the Consumer is  
   * @param {string} phone the Consumer's phone number
	 * @returns none
	 */
  self.doRequest = function (callbackFn, locationId, phone) {
    self.lastSeen(null);

    if (!phone || !locationId) {
      var selectedConsumer = vm.selectedConsumer();

      if (selectedConsumer) {
        var queue = vm.queuesWS.getQueueById(selectedConsumer.queueId);
        locationId = queue.locationId;
        phone = selectedConsumer.phone;
      }
    }


    if (phone && locationId) {
      self.reset();
      self.addParam('phone', phone.replace(/[^0-9]/g, ''));
      self.serviceURL = ko.computed(function () {
        return '/qless/api/v1/employee/location/' + locationId  + '/consumer';
      });

      AbstractWS.prototype.doRequest.call(self, callbackFn);
    }
  };


	/**
	 * Converts returned XML data into SpotModels, with custom properties
	 *
	 * @method processData
	 * @param {XMLString} xmlData
	 * @returns {ConsumerSearchWS}
	 */
  self.processData = function (data) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data);
    self.lastSeen(vm.messagesWS.get('never'));

    var json = xmlToJson.parse(data);

    if (json) {
      var info = json.info || json.merchantConsumerInfos.info;
      if (info) {
        self.consumerName = info.name;
        var lastSeen = info.lastSeen;

        if (lastSeen) {
          var m = new moment(lastSeen);
          self.lastSeen(m.format('lll'));
        }

        self.notes(info.notes ? info.notes : "");
      }
      else {
        self.consumerName = null;
      }
    }
  };

  self.reset  = function () {
    AbstractWS.prototype.reset.apply(self);
    self.notes("")
  }

  return self;
};

ConsumerInfoWS.prototype = Object.create(AbstractWS.prototype);
ConsumerInfoWS.prototype.constructor = ConsumerInfoWS;

module.exports = ConsumerInfoWS;
